import { usePartyStore } from '@/features/parties/store';
import { IReportParty } from '@/features/reports/models';
import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const createColumns = (): ColumnDef<IReportParty>[] => {
  const { t } = useTranslation();
  const { cropTypes } = usePartyStore();

  return useMemo(
    () => [
      {
        accessorKey: 'crop_type_name',
        header: () => t('selection.type.variety'),
      },
      {
        accessorKey: 'party_number',
        header: () => t('party.number'),
      },
      {
        accessorKey: 'place_number',
        header: () => t('place.number'),
      },
      {
        accessorKey: 'industrial_grade',
        header: () => t('industry.type'),
      },
      {
        accessorKey: 'class',
        header: () => t('class'),
      },
      {
        accessorKey: 'total_receptions',
        header: () => t('total.reception'),
      },
      {
        accessorKey: 'total_weight',
        header: () => t('conditional.weight'),
      },
      {
        accessorKey: 'avg_humidity',
        header: () => t('humidity'),
      },
      {
        accessorKey: 'total_weight_calc',
        header: () => t('calculated.weight2'),
      },
      {
        accessorKey: 'avg_pollution',
        header: () => t('pollution'),
      },
      {
        accessorKey: 'total_weight_cond',
        header: () => t('cond.weight'),
      },
    ],
    [cropTypes],
  );
};
